import api from '@/lib/api';
import type { ApiResponse, PaginationMeta, UserNotification } from '@amuster/types';

export interface InboxListQuery {
  page?: number;
  limit?: number;
  unread?: boolean;
}

export const notificationsService = {
  getUnreadCount() {
    return api.get<ApiResponse<{ count: number }>>('/notifications/unread-count');
  },

  listInbox(query?: InboxListQuery) {
    return api.get<ApiResponse<UserNotification[]> & { meta: PaginationMeta }>(
      '/notifications/inbox',
      { params: query }
    );
  },

  markRead(id: string) {
    return api.post<ApiResponse<UserNotification>>(`/notifications/${id}/read`);
  },

  readAll() {
    return api.post<ApiResponse<{ updated: number }>>('/notifications/read-all');
  },
};

